import { Button } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalFooter,
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import LoadingDots from '@trustoo/components/ui/LoadingDots'
import { useModalToast } from 'components/misc/Toaster'
import { useState } from 'react'
import { getRejectionMessage } from 'utils/getRejectionMessage'

interface Props {
    onConfirm: () => Promise<void>
}

const FreeTrialCancelModal = NiceModal.create(({ onConfirm }: Props) => {
    const modal = useModal()
    const { addModalToast } = useModalToast()
    const [isSaving, setIsSaving] = useState(false)

    const closeModal = () => {
        modal.resolve()
        modal.hide()
    }

    const handleConfirm = async () => {
        setIsSaving(true)

        try {
            await onConfirm()
            closeModal()
        } catch (rejection) {
            // Stays in the modal: nothing was cancelled, and the button is the retry.
            addModalToast({
                id: 'save-error',
                msg: getRejectionMessage(
                    rejection,
                    'Something went wrong while cancelling the trial',
                ),
                icon: 'error',
                red: true,
            })
        } finally {
            setIsSaving(false)
        }
    }

    return (
        <BaseModal
            closeOnOutSideClick={false}
            preventClose={isSaving}
            mobileFullscreen
            maxWidth={674}>
            <BaseModalHeader>
                <h2 className="text-xl font-bold">Cancel the free trial</h2>
            </BaseModalHeader>
            <BaseModalMainContent>
                This will remove the free trial leads and end the free trial. Are you sure?
            </BaseModalMainContent>
            <BaseModalFooter className="flex flex-wrap justify-between gap-2">
                <Button name="link" onClick={closeModal} disabled={isSaving}>
                    No, go back
                </Button>
                <Button onClick={handleConfirm} disabled={isSaving}>
                    {isSaving ? <LoadingDots /> : 'Yes, cancel the free trial'}
                </Button>
            </BaseModalFooter>
        </BaseModal>
    )
})

export default FreeTrialCancelModal
